import "./header.css";
import {Link, useLocation, useNavigate} from "react-router-dom";
import paths from "../../paths";
import React, {useEffect, useState} from "react";
import {auth, authSubject} from "../../store/auth.store";
import {copyMemberNumber, CurrencyFormat, useForceUpdate} from "../../services/misc.functions";
import iconMenu from "../../assets/feather/menu.svg";
import iconMember from "../../assets/feather/user.svg";
import iconPhone from "../../assets/feather/phone.svg";
import iconTickets from "../../assets/feather/clipboard.svg";
import iconDeposit from "../../assets/feather/download.svg";
import iconWithdraw from "../../assets/feather/upload.svg";
import iconPassword from "../../assets/feather/lock.svg";
import iconPocket from "../../assets/feather/server.svg";
import iconTransactions from "../../assets/feather/list.svg";
import iconLogout from "../../assets/feather/log-out.svg";
import iconHeadphones from "../../assets/feather/headphones.svg";
import iconCampaign from "../../assets/icons/campaign.svg";
import iconGiftTicket from "../../assets/icons/tickets.svg";
import iconNotification from "../../assets/feather/bell.svg";
import couponIcon from "../../assets/icons/coupon-icon.svg"
import iconSession from "../../assets/feather/link.svg";
import {isMobile} from "../../App";
import {path} from "../../store/misc.store";
import {AuthService} from "../../services/auth.service";
import {modalServiceSubject} from "../../services/modal.service";

function UserMenu() {
    const forceUpdate = useForceUpdate();
    useEffect(() => {
        let auth_subscriber = authSubject.subscribe((res: any) => {
            forceUpdate();
        });
        return () => {
            auth_subscriber.unsubscribe();
        };
    }, []);

    return (
        <ul id="member-dropdown-menu" className="member-dropdown-menu">
            <li>
                <Link to={paths.memberInfo.url}>
                    <img className="svgcolor" src={iconMember} alt="-"/> HESABIM
                </Link>
            </li>

            <li>
                <Link to={paths.memberTickets.url}>
                    <img className="svgcolor" src={iconTickets} alt="-"/>
                    BİLETLERİM
                </Link>
            </li>

            <li>
                <Link to={paths.memberVirtualTickets.url}>
                    <img className="svgcolor" src={iconTickets} alt="-"/>
                    SANAL OYUN BİLETLERİM
                </Link>
            </li>

            <li>
                <Link to={paths.memberNumericTickets.url}>
                    <img className="svgcolor" src={iconTickets} alt="-"/>
                    SAYISAL OYUN BİLETLERİM
                </Link>
            </li>

            <li>
                <Link to={paths.notifications.url}>
                    <img className="svgcolor" src={iconNotification} alt="N"/>
                    BİLDİRİMLERİM
                    {auth?.member?.unread_notification_count && auth.member.unread_notification_count > 0 ? (
                        <span
                            className="d-flex align-items-center justify-content-center text-center text-white badge rounded-pill bg-danger me-0 ms-3">
              {auth.member.unread_notification_count}
            </span>
                    ) : (
                        <></>
                    )}
                </Link>
            </li>

            <li>
                <Link to={paths.memberSessions.url}>
                    <img className="svgcolor" src={iconSession} alt="-"/> OTURUMLARIM
                </Link>
            </li>

            <li>
                <Link to={paths.notificationInfo.url}>
                    <img className="svgcolor" src={iconPhone} alt="-"/> İLETİŞİM TERCİHLERİ
                </Link>
            </li>

            <li>
                <Link to={paths.deposit.url}>
                    <img className="svgcolor" src={iconDeposit} alt=""/>
                    PARA YATIR
                </Link>
            </li>
            <li>
                <Link to={paths.withdraw.url}>
                    <img className="svgcolor" src={iconWithdraw} alt="-"/>
                    PARA ÇEK
                </Link>
            </li>

            <li>
                <Link to={paths.couponCode.url}><img className="svgcolor" src={iconLogout} alt="-"/>
                    <img className="svgcolor" src={couponIcon} alt="-"/>
                    KUPON KODU
                </Link>
            </li>

            <li>
                <Link to={paths.changePassword.url}>
                    <img className="svgcolor" src={iconPassword} alt="-"/>
                    ŞİFRE DEĞİŞTİR
                </Link>
            </li>

            <li>
                <Link to={paths.memberBankAccounts.url}>
                    <img className="svgcolor" src={iconPocket} alt="-"/>
                    BANKA HESAPLARIM
                </Link>
            </li>
            <li>
                <Link to={paths.memberTransactions.url}>
                    <img className="svgcolor" src={iconTransactions} alt="-"/>
                    HESAP HAREKETLERİ
                </Link>
            </li>
            <li>
                <Link to={paths.giftTicket.url}>
                    <img className="svgcolor" src={iconGiftTicket} alt="-"/>
                    HEDİYE BİLETLERİM
                </Link>
            </li>
            <li>
                <Link to={paths.support.url + "/cozum-merkezi"}>
                    <img className="svgcolor" src={iconHeadphones} alt="-"/>
                    YARDIM
                </Link>
            </li>
            <li>
                <Link to={paths.announcement.url}>
                    <img className="svgcolor" src={iconCampaign} alt="-"/>
                    DUYURULAR
                </Link>
            </li>
            <li>
                <a
                    className="cursor-pointer"
                    onClick={() => {
                        const authService = new AuthService();
                        authService.logout();
                    }}
                >
                    <img className="svgcolor" src={iconLogout} alt="-"/>
                    ÇIKIŞ YAP
                </a>
            </li>
        </ul>
    );
}

export function Header() {
    const forceUpdate = useForceUpdate();
    const {pathname} = useLocation();
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState(false);

    useEffect(() => {
        let auth_subscriber = authSubject.subscribe((res: any) => {
            forceUpdate();
        });
        return () => {
            auth_subscriber.unsubscribe();
        };
    }, []);

    useEffect(() => {
        forceUpdate();
        setShowMenu(false);
    }, [pathname]);

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, []);

    const handleClickOutside = (event: any) => {
        let ref: any = document.getElementById("member-dropdown-menu");
        if (ref?.contains(event.target) === true) {
        } else {
            if (event.target.id !== "menu") {
                setShowMenu(false);
            }
        }
    };

    const handleOpenBalanceDetails = () => {
        modalServiceSubject.next({
            title: "",
            width: "400px",
            content: <BalanceDetails/>
        })
    }


    if (isMobile && path.root === paths.register.url.replace("/", "")) {
        return <></>;
    }

    return (
        <header>
            <h5 className="my-0  font-weight-normal ">
                <Link to={paths.home.url}>
                    <img className="nav-logo" alt="4NALA" src="/assets/logo_at_yarisi_hipodrom_4nala_atyarisi.svg"/>
                </Link>
            </h5>

            {!isMobile && (
                <nav className="ms-auto">
                    {auth.authentication && auth.member && auth.member.id ? (
                        <>
                            <div
                                className="user-balance"
                                onClick={handleOpenBalanceDetails}
                            >
                                <label>Bakiye:</label>
                                <div className="lines">
                                    <span>{auth.member.balance_debit}₺</span>
                                    <span>{Number(auth.member.balance_point).toFixed(2)}P</span>
                                </div>
                            </div>

                            <div
                                className="user-tickets"
                                onClick={() => {
                                    navigate(paths.memberTickets.url);
                                }}
                            >
                                BİLETLERİM
                            </div>
                            <div className="user-profile">
                                <a
                                    className="float-end mt-2 cursor-pointer"
                                    onClick={() => {
                                        setShowMenu((prevShowMenu) => !prevShowMenu);
                                    }}
                                >
                                    <img src={iconMenu} alt="N" id={"menu"}/>
                                </a>

                                <span className="nowrap-ellipsis pe-2">
                  {" "}
                                    <b>{auth.member.first_name}</b>
                </span>
                                <span
                                    onClick={() => {
                                        copyMemberNumber(auth.member.id, "Üye numaranız kopyalandı!");
                                    }}
                                >
                  {" "}
                                    <b>{auth.member.id}</b>
                </span>

                                {showMenu && <UserMenu/>}
                            </div>
                        </>
                    ) : (
                        <>
                            <Link className="login" to={paths.login.url}>
                                GİRİŞ YAP
                            </Link>
                            <Link className="register" to={paths.register.url}>
                                ÜYE OL
                            </Link>
                        </>
                    )}
                </nav>
            )}

            {isMobile && (
                <nav className="float-end">
                    {auth.authentication && auth.member && auth.member.id ? (
                        <>
                            <div className={"menu-button"}>
                                <a
                                    className="float-end mt-2 cursor-pointer"
                                    onClick={() => {
                                        setShowMenu((prevShowMenu) => !prevShowMenu);
                                    }}
                                >
                                    <img src={iconMenu} alt="N" id={"menu"}/>
                                </a>
                            </div>
                            <div
                                className="user-balance d-flex align-items-center"
                                onClick={handleOpenBalanceDetails}
                            >
                                <div className="lines">
                                    <span>{auth.member.balance_debit}₺</span>
                                    <span>{Number(auth.member.balance_point).toFixed(2)}NP</span>
                                </div>
                            </div>
                            <div
                                className="user-notification"
                                onClick={() => {
                                    navigate(paths.notifications.url);
                                }}
                            >
                                <img src={iconNotification} alt="N"/>
                                {auth?.member?.unread_notification_count && auth.member.unread_notification_count > 0 ? (
                                    <span
                                        className="position-absolute px-2 translate-middle text-white badge rounded-pill bg-danger">
                    {auth.member.unread_notification_count}
                  </span>
                                ) : (
                                    <></>
                                )}
                            </div>
                            <div
                                className="user-profile"
                                onClick={() => {
                                    setShowMenu((prevShowMenu) => !prevShowMenu);
                                }}
                            >
                <span className={"user-name"}>
                  <b>{auth.member.first_name}</b>
                </span>
                                <span
                                    onClick={() => {
                                        copyMemberNumber(auth.member.id, "Üye numaranız kopyalandı!");
                                    }}
                                >
                  <b>{auth.member.id}</b>
                </span>
                                {showMenu && <UserMenu/>}
                            </div>
                        </>
                    ) : (
                        <>
                            <Link className="btn btn-sm register" to={paths.register.url}>
                                ÜYE OL
                            </Link>
                            <Link className="btn btn-sm login" to={paths.login.url}>
                                GİRİŞ YAP
                            </Link>
                        </>
                    )}
                </nav>
            )}
        </header>
    );
}

function BalanceDetails() {
    return (
        <div>
            <p><b>Kullanılar Bakiye</b></p>

            <p>2 tip NP Puan vardır</p>

            <ul>
                <li>İkramiye NP Puan: Oyunlarda kazanılan NP puanlardır.</li>
                <li>Bonus NP Puan: Kampanyalardan kazanılan NP puanlardır.</li>
            </ul>

            <p>
                TL Bakiyeniz ve NP Puanınız ile oyun oynayabilirsiniz. Ödül kataloğundan sadece oyunlardan kazanılan NP puanlarınız ile ödül alabilirsiniz.
            </p>

            <table className={"table table-bordered"}>
                <tbody>
                    <tr>
                        <td className={"text-primary"}><b>TL Bakiye</b></td>
                        <td className={"fw-bold"}>{CurrencyFormat(auth.member.balance_debit_available, 2)} TL</td>
                    </tr>
                    <tr>
                        <td className={"text-primary"}><b>İkramiye NP Puan</b></td>
                        <td className={"fw-bold"}>{CurrencyFormat(auth.member.balance_point_available, 2)} NP</td>
                    </tr>
                    <tr>
                        <td className={"text-primary"}><b>Bonus NP Puan</b></td>
                        <td className={"fw-bold"}>{CurrencyFormat(Number(auth.member.balance_point) - Number(auth.member.balance_point_available), 2)} NP</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}
